import React from "react";
import img3 from "../images/image 3.png";

function Partnerships() {
  return (
    <div style={{ textAlign: "center" }}>
      <h1 style={{ fontWeight: "bold" }}>Partnerships</h1>
      <div style={{ width: "auto", marginLeft: 20, marginRight: 20 }}>
        <img style={{ height: "auto", maxWidth: "100%" }} src={img3} />
      </div>
    </div>
  );
}

export default Partnerships;
